export const environment = {
  production: false,
  maintenance: false,
  apiUrl: 'https://dev-client.docketscope.com/api/',
  oauth2Url: 'https://dev-client.docketscope.com/oauth2/',
  cognitoMfaApiUrl: 'https://dev-client.docketscope.com/api-cognito_mfa/',
  cognitoMfaOauth2Url: 'https://dev-client.docketscope.com/oauth2-cognito_mfa/',
};